import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4
};

export default function BasicModal(props) {
  return (
    <div>
      <Modal
        open={true}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: props.width,
            height: props.height,
            overflow: 'hidden'
          }}
        >
          {props.children}
        </Box>
      </Modal>
    </div>
  );
}

BasicModal.propTypes = {
  handleClose: propTypes.func,
  width: propTypes.number,
  height: propTypes.number,
  children: propTypes.any
};
